export default "__VITE_ASSET__B8Bb2MGk__"